enum PRICING_TYPES {
  normal = 'normal',
  discount = 'discount',
  promotions = 'promotions',
  notAvailable = 'notAvailable'
}

export default PRICING_TYPES
